import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { errorMessage, errorToString } from "@/error/errorUnwrapper";
import { Counter } from "@/model/Counter";
import { statHistory } from "@/model/Settings";
import type { Statistics } from "@/model/baseTypes";
import { asReadonly } from "@/utils/vue";

export const statsProvider = {
  subscriptions: () => 0,
  storesLen: () => 0,
};

export const useStatisticsStore = defineStore("statistics", () => {
  const statistics = ref([newEntry()]);

  const current = computed(() => statistics.value[statistics.value.length - 1]);

  return {
    statistics: asReadonly(statistics),
    current,

    start: () =>
      setInterval(() => {
        statistics.value.push(newEntry(current.value));
        if (statistics.value.length > statHistory) {
          statistics.value.splice(0, 1);
        }
      }, 5000),
    addOk: (type: StatisticsCounter) => current.value[type].addOk(),
    addFail: (type: StatisticsCounter, detail?: unknown) => {
      const key = detail ? errorMessage(detail, errorToString(detail, "Unknown")) : undefined;
      current.value[type].addFail(key);
    },
  };
});

type StatisticsCounter = keyof Pick<Statistics, "receives" | "calls" | "publishes" | "sends">;

function newEntry(oldEntry?: Statistics): Statistics {
  return {
    receives: new Counter(oldEntry?.receives),
    calls: new Counter(oldEntry?.calls),
    publishes: new Counter(oldEntry?.publishes),
    sends: new Counter(oldEntry?.sends),
    subscriptions: statsProvider.subscriptions(),
    reconnects: oldEntry?.reconnects || 0,
    storesLen: statsProvider.storesLen(),
  };
}
